import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './componentCss/VerticalProjectList.module.css';

// Simple vertical list of projects without links. Supports long text with proper wrapping.
const VerticalProjectList = () => {
  const { t } = useTranslation();

  const projects = [
    // RTE
    // { img: 'Logo_RTE.png', title: t('Projects.RTE-ImmersiveVR'), desc: t('Projects.RTE-ImmersiveVR-desc'), client: { logo: 'Logo_RTE.png', alt: 'RTE' } },
    // { img: 'Logo_RTE.png', title: t('Projects.RTE-AR-Router'), desc: t('Projects.RTE-AR-Router-desc'), client: { logo: 'Logo_RTE.png', alt: 'RTE' } },

    // TOTAL
    // { img: 'Logo_Total.png', title: t('Projects.Total-DigitalTwin'), desc: t('Projects.Total-DigitalTwin-desc'), client: { logo: 'Logo_Total.png', alt: 'TotalEnergies' } },

    // // ONET
    // { img: 'Onet_Icon.png', title: t('Projects.Onet-Teleop'), desc: t('Projects.Onet-Teleop-desc'), client: { logo: 'Onet_Icon.png', alt: 'Onet' } },

    // // FERRING
    // { img: 'Ferring_Icon.png', title: t('Projects.Ferring-VRTraining'), desc: t('Projects.Ferring-VRTraining-desc'), client: { logo: 'Ferring_Icon.png', alt: 'Ferring' } },

    // GSK group
    { img: 'GSK_Icon.png', title: t('Projects.GSK-VRTrainer'), desc: t('Projects.GSK-VRTrainer-desc'), client: { logo: 'GSK_Icon.png', alt: 'GSK' } },
    // INSERTED CUSTOM CARD AFTER VRTrainer
    { custom: true, img: 'img/Photos/GSK1.jpg', title: t('Projects.Custom.GSK1') },

    { img: 'GSK_Icon.png', title: t('Projects.GSK-PharmaRobot'), desc: t('Projects.GSK-PharmaRobot-desc'), client: { logo: 'GSK_Icon.png', alt: 'GSK' } },
    { img: 'GSK_Icon.png', title: t('Projects.GSK-OnlineLibrary'), desc: t('Projects.GSK-OnlineLibrary-desc'), client: { logo: 'GSK_Icon.png', alt: 'GSK' } },
    { img: 'GSK_Icon.png', title: t('Projects.GSK-VisualQC'), desc: t('Projects.GSK-VisualQC-desc'), client: { logo: 'GSK_Icon.png', alt: 'GSK' } },
    { img: 'GSK_Icon.png', title: t('Projects.GSK-SiteTour'), desc: t('Projects.GSK-SiteTour-desc'), client: { logo: 'GSK_Icon.png', alt: 'GSK' } },
    { img: 'GSK_Icon.png', title: t('Projects.GSK-VRTaskEditor'), desc: t('Projects.GSK-VRTaskEditor-desc'), client: { logo: 'GSK_Icon.png', alt: 'GSK' } },
    // INSERTED CUSTOM CARD AFTER VRTaskEditor
    { custom: true, img: 'img/Photos/GSK2.png', title: t('Projects.Custom.GSK2') },

    { img: 'GSK_Icon.png', title: t('Projects.GSK-XREditor'), desc: t('Projects.GSK-XREditor-desc'), client: { logo: 'GSK_Icon.png', alt: 'GSK' } },

    // BIOTECH CAMPUS
    { img: 'Logo_biotech.png', title: t('Projects.BiotechCampus-VR'), desc: t('Projects.BiotechCampus-VR-desc'), client: { logo: 'Logo_biotech.png', alt: 'Biotech Campus' } },
  ];

  return (
    <div className={styles.container}>
      {projects.map((p, idx) => (
        <div key={idx} className={`${styles.item} ${p.custom ? styles.customItem : ''}`}>
          <div className={p.custom ? styles.customImageWrap : styles.imageWrap}>
            <img
              className={p.custom ? styles.customImage : styles.image}
              src={p.custom ? `${process.env.PUBLIC_URL}/${p.img}` : `${process.env.PUBLIC_URL}/img/ProjectImages/${p.img}`}
              alt={typeof p.title === 'string' ? p.title : ''}
              loading="lazy"
            />
          </div>
          <div className={styles.content}>
            {p.custom ? (
              <p className={styles.customText}>{p.title}</p>
            ) : (
              <>
                <h3 className={styles.title}>{p.title}</h3>
                <p className={styles.desc}>{p.desc}</p>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default VerticalProjectList;
